import React from 'react'
import { useDispatch } from 'react-redux'

import { DEFAULT_JOBS_QUERY_PARAMS } from 'constants/projects'
import { toProjects } from 'ducks/router'

export const useHome = () => {
  const dispatch = useDispatch()

  React.useEffect(() => {
    dispatch(toProjects(null, null, DEFAULT_JOBS_QUERY_PARAMS))
  }, [dispatch])
}
